import React, { useEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import api from "../../api/api";
import dollarImage from "../../../src/assets/Signin/Dollar.svg";
import ToastMessage from "../../utils/mui/righttoptoast";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import PersonalVideoIcon from "@mui/icons-material/PersonalVideo";
import cancelledDesk from "../../../src/assets/Signin/FrontCancel.svg";
import ConfirmFrontdesk from "../../signin/popups/ConfirmFrontdesk";
import { retrive } from "./svgs";
import { set } from "date-fns";
import { Backdrop, CircularProgress } from "@mui/material";
import ProviderModal from "./Providermodal";
import { useDispatch, useSelector } from "react-redux";
import PurposeOfVisitModal from "./purposeofvisitmodal";
import InsurancePlansModal from "./insuranceplanmodal";
import { showToast } from "../../reduxtoolkit/toastslice";
import { calculatePatientCopay } from "../cards/patientcalculator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
const Paymentsmodal = ({
  closePaymentModal,

  alldata = [],
  setFetchedData,
  fetchedData,
  costEstimate = 0,
  data,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("payment");
  const homescreenprev = useSelector(
    (state) => state.userPrivileges.homescreen,
  );
  const [showPaymentsHistory, setShowPaymentsHistory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [purposeModalOpen, setPurposeModalOpen] = useState(false);
  const [PaymentMethod, setPaymentMethod] = useState([]);
  const [providerModalOpen, setProviderModalOpen] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [copay, setCopay] = useState(0.0);
  const [selfPay, setSelfPay] = useState(0.0);
  const [coinsurance, setCoinsurance] = useState(0.0);
  const [loader, setLoader] = useState(false);
  const [deductible, setDeductible] = useState(0.0);
  const [frontDesk, setFrontDesk] = useState("");
  const [totalAmount, setTotalAmount] = useState(0.0);
  const [paymentOnAccount, setPaymentOnAccount] = useState("");
  const [ccnumber, setCcnumber] = useState("");
  const [frontdeskModal, setfrontdeskModal] = useState(false);
  const loginUser = localStorage.getItem("user");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [getpaymentData, setGetpaymentData] = useState(null);
  const [alertmessage, setAlertMessage] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedTab, setSelectedTab] = useState("");
  const navigate = useNavigate();
  const [insuranceModalOpen, setInsuranceModalOpen] = useState(false);
  const [selectedPlans, setSelectedPlans] = useState([]);
  const userConfig = useSelector((state) => state.userconfig);
  const practiseid = window.getPracticeId();
  const[prevamount,setPrevamount]=useState('')
    const tab = useSelector((state) => state.filter.tab);
      const currentDate = useSelector((state) => state.filter.currentDate);
  let insuranceCoveredPlan = [
    "VISIT",
    "Labs",
    "Injections",
    "EKG",
    "ULTRASOUND",
    "SLEEP STUDY",
    "ECHO",
    "RPM"
  ];
  const dispatch = useDispatch();

  const currentPatient = alldata[currentIndex] || {};

  const {
  costEstimate: patientCostEstimate,
  finalCopayTotal,
  finalformattedTotalcopay
} = calculatePatientCopay(currentPatient);

  const handlealert = (_, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

function formatDateTime(dateInput, timeInput) {
  if (!dateInput) return "";

  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "";

  // Format only the date part
  const formattedDate = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return `${formattedDate} ${timeInput || ""}`;
}
const fetchprevamount = async () => {
  try {
    const response = await api.post(
      `/v1/${practiseid}/patient/${data.patientid}/appointment/payment-details`,
      {
        appointmentid: data.appointmentid,
        startdate: dayjs().format("YYYY-MM-DD"),
      }
    );

    if (response.status === 200) {
      const payments = response?.data;
  setPrevamount(payments)
    } else {
      setPrevamount([]);
    }
  } catch (error) {
    console.log(error);
    setPrevamount(0);
  }
};

  useEffect(() => {
    const foundIndex = alldata.findIndex((p) => p.patientid === data.patientid);
    setCurrentIndex(foundIndex !== -1 ? foundIndex : 0);
  }, [alldata, data]);
  useEffect(() => {
    fetchFrontDesk();
    handleGetPayment({ data: currentPatient });
    fetchprevamount()
  }, [currentPatient]);
  useEffect(() => {
    const initialTotal =
      (parseFloat(copay) || 0) +
      (parseFloat(selfPay) || 0) +
      (parseFloat(paymentOnAccount) || 0);
    let totalAfter = initialTotal;
    if (coinsurance) {
      totalAfter -= parseFloat(deductible) || 0;
      setDeductible(0);
    }
    setTotalAmount(totalAfter.toString());
  }, [copay, selfPay, paymentOnAccount, deductible, coinsurance]);
  useEffect(() => {
    if (userConfig?.grole == 2 || userConfig?.grole == 3) {
      setActiveTab("update"); // Pay tab
    } else {
      setActiveTab("payment"); // Update tab
    }
  }, [userConfig]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await api.get(
        `/v1/${practiseid}/payments/payment-methods`,
      );

      setPaymentMethod(response.status === 200 ? response.data : []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const fetchUpdateFrontDesk = async ({ frontDesk, data }) => {
    try {
      const response = await api.put(
        `/v1/${practiseid}/appointments/patient/${data.patientid}/front_desk`,
        {
          appointmentid: data.appointmentid,
          is_front_desk: frontDesk,
        },
      );
      fetchFrontDesk();
    } catch (error) {
      console.error("Error updating front desk:", error);
    }
  };
  const handleGetPayment = async ({ data }) => {
    setLoader(true)
    const dateString = data.startdate;
    const formattedDate = new Date(dateString).toLocaleDateString("en-CA");
    try {
      const response = await api.post(
        `/v1/${practiseid}/patient/${data?.patientid}/view-payments`,
        {
          appointmentid: data.appointmentid,
          startdate: formattedDate,
        },
      );
      if (response.status === 200) {
        setGetpaymentData(response.data);
      }
    } catch (error) {
      console.error("Error fetching payment:", error);
    }finally{
      setLoader(false)
    }
  };
  const handleGetpreviousPayment = async ({ data }) => {
    setLoader(true);
    try {
      const response = await api.post(
        `/v1/${practiseid}/appointments/${data?.patientid}/update-deductible`,
      );

      if (response.status == 200) {
        setAlertMessage("Payments retrieved successfully");
        setSeverity("success");
        setOpen(true);
        handleGetPayment({ data: data });
      } else {
        setAlertMessage(response.message);
        setSeverity("info");
        setOpen(true);
      }
    } catch (error) {
      console.error("Error fetching payment:", error);
      setAlertMessage("something went wrong");
      setSeverity("error");
      setOpen(true);
    } finally {
      setLoader(false);
    }
  };
  const fetchFrontDesk = async () => {
    try {
      const response = await api.post(
        `/v1/${practiseid}/appointments/patient/${currentPatient?.patientid}/get_front_desk`,
        {
          appointmentid: data.appointmentid,
        },
      );
      if (response.status === 200) {
        setFrontDesk(response?.is_front_desk || "");
      }
    } catch (error) {
      console.error("Error fetching front desk:", error);
    }
  };
  const hanldeFrontdeskModal = () => {
    setfrontdeskModal(true);
  };
  const handleFrontDeskToggle = () => {
    const newStatus = frontDesk === "Y" ? "N" : "Y";
    setFrontDesk(newStatus);
    fetchUpdateFrontDesk({ frontDesk: newStatus, data: currentPatient });
    // is_front_desk

        setFetchedData((prevData) =>
            prevData.map((item) =>
              item.id === data?.id ? { ...item,is_front_desk:newStatus } : item
            )
          );
  };

  useEffect(() => {
    fetchData();
    
  }, []);

  const handleCcnumberChange = (e) => setCcnumber(e.target.value);

  const handlePaymentMethodChange = (e) => {
    const selectedId = e.target.value;
    const selectedMethod = PaymentMethod.find(
      (payment) => payment.id === parseInt(selectedId),
    );
    setSelectedPaymentMethod(selectedMethod);
    setCcnumber("");
  };
  useEffect(() => {
    if (getpaymentData && activeTab === "payment") {
      setCopay(getpaymentData.copay || 0.0);
      setSelfPay(getpaymentData.selfpay || 0.0);
      setDeductible(getpaymentData.deductibleamt || 0.0);
      setPaymentOnAccount(getpaymentData.acctbalance || 0.0);
    } else if (activeTab === "update") {
      setCopay("");
      setSelfPay("");
      setPaymentOnAccount("");
      setCoinsurance("");
      setDeductible("");
      setTotalAmount("0");
    }
  }, [activeTab, getpaymentData]);
  const handlePaySubmit = async () => {

      // Check if the payment method is selected
  if (!selectedPaymentMethod?.id) {
    dispatch(
      showToast({
        message: "Please select a payment method.",
        severity: "error",
      })
    );
    return;
  }

  if (selectedPaymentMethod.method === "CHECK" && ccnumber === '') {
  dispatch(
    showToast({
      message: "Please enter check number.",
      severity: "error",
    })
  );
  return;
} else if (selectedPaymentMethod.method !== "CASH") {
  // Only check if ccnumber is not empty and matches the format for non-CASH methods
  if (!ccnumber || !/^\d{4}$/.test(ccnumber)) {
    dispatch(
      showToast({
        message: "Please enter the last 4 digits of the card number.",
        severity: "error",
      })
    );
    return;
  }
}


  // Check if the amount fields have valid values (non-negative)
  const copayValue = parseFloat(copay) || 0;
  const selfPayValue = parseFloat(selfPay) || 0;
  const paymentOnAccountValue = parseFloat(paymentOnAccount) || 0;
  const totalAmountValue = parseFloat(totalAmount) || 0;
  if (copayValue < 0 || selfPayValue < 0 || paymentOnAccountValue < 0 || totalAmountValue < 0) {
    dispatch(
      showToast({
        message: "Please enter a valid amount (cannot be negative).",
        severity: "error",
      })
    );
    return;
  }
  // Validate that totalAmount is equal to the sum of copay, selfpay, and paymentonaccount
  // const expectedTotalAmount = copayValue + selfPayValue + paymentOnAccountValue;
  // if (totalAmountValue !== expectedTotalAmount) {
  //   dispatch(
  //     showToast({
  //       message: "Total Amount should match the sum of Co-pay, Self Pay, and Payment on Account.",
  //       severity: "error",
  //     })
  //   );
  //   return;
  // }

  if (totalAmountValue === "" || totalAmountValue <= 0) {
    dispatch(
      showToast({
        message: "Please enter a valid amount.",
        severity: "error",
      })
    );
    return;
  }

    const payload = {
      department_id: 1,
      patientname: `${currentPatient.firstname} ${currentPatient.lastname}`,
      appointmentid: currentPatient.appointmentid,
      amount: totalAmount,
      paymentmethodid: selectedPaymentMethod?.id,
      paymentmethod: selectedPaymentMethod?.type,
      ccnumber: ccnumber,
      paymentstatus: "success",
      paymentlocation: "Practice App",
      paymenttype: selectedPaymentMethod?.type,
      // copay: copay||0,
      // paymentonaccount: paymentOnAccount||0,
      insurance: currentPatient.insurancename,
      // selfpay: selfPay,
      createdby: loginUser,
    };
    if (selfPay) {
      payload.selfpay = selfPay;
    }
    if (copay) {
      payload.copay = copay;
    }
    if (paymentOnAccount) {
      payload.paymentonaccount = paymentOnAccount;
    }
    try {
      setLoading(true);
      const response = await api.post(
        `/v1/${practiseid}/patient/${currentPatient.patientid}/payments/take-payments`,
        payload,
      );

      if (response.status == 200) {
        //     setAlertMessage('Payment processed successfully.');
        // setSeverity("success");
        // setOpen(true);
        let payload = {
  appointmentdate: currentDate,
  searchflag: currentPatient.patientid,
  dashfilter: null,
  filterarr: [],
  start: 0,
  limit: 0,
};

const dashboarddata = await api.post(
  `/v1/${practiseid}/appointments/dashboard`,
  payload
);

setFetchedData((prevData) => {
  // Check API success and valid data
  if (
    dashboarddata?.status === 200 &&
    dashboarddata?.data?.length > 0
  ) {
    const apiItem = dashboarddata.data[0];

    return prevData.map((item) =>
      item.id === apiItem.id
        ? { ...item, ...apiItem } // ✅ Replace with complete API object
        : item
    );
  }

  // ❌ If condition fails → fallback to your original logic
  return prevData.map((item) =>
    item.id === data.id
      ? {
          ...item,
          copay: copay || 0,
          acctbalance: paymentOnAccount || 0,
        }
      : item
  );
});

        dispatch(
          showToast({
            message: "Payment processed successfully",
            severity: "success",
          }),
        );
        closePaymentModal();
        //     setTimeout(() => {

        // }, 1200);
      } else {
        //        setAlertMessage(response.message);
        // setSeverity("info");
        // setOpen(true);
        dispatch(
          showToast({
            message: response.message,
            severity: "info",
          }),
        );
      }

      // if (response.status !== 200) {
      //   setTimeout(() => navigate('/landing'), 1000);
      // }
    } catch (error) {
      console.error("Error submitting payment:", error);
      dispatch(
        showToast({
          message: "Something went wrong",
          severity: "error", // or "info" if you prefer
        }),
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const colorTabMap = {
      "58D68D": "Covered",
      F9E79F: "Coinsurance",
      F3082C: "Deductible",
    };

    const color = currentPatient?.deductiblemet;

    if (colorTabMap[color]) {
      setSelectedColor(color);
      setSelectedTab(colorTabMap[color]);
    } else {
      setSelectedColor("");
      setSelectedTab("");
    }
  }, [currentPatient]);
  const handleUpdatePay = async () => {
    const formattedStartDate = dayjs(currentPatient.startdate).format(
      "YYYY-MM-DD",
    );
    const payload = {
      patientname: `${currentPatient.firstname} ${currentPatient.lastname}`,
      appointmentid: currentPatient.appointmentid,
      location: "Practice App",
      insurance: currentPatient.insurancename,
      copay: copay || 0.0,
      accountbalance: paymentOnAccount || 0.0,
      deductibleamt: deductible || 0.0,
      coinsurancepercent: coinsurance || 0.0,
      selfpaybalance: selfPay || 0.0,
      amount: totalAmount || 0.0,
      searchdate: formattedStartDate,
      createdby: loginUser,
    };
    setLoading(true);
    try {
      const response = await api.put(
        `/v1/${practiseid}/patient/${currentPatient.patientid}/payments/updatepaymentupdate`,
        payload,
      );
      if (response.status == 200) {
let payload = {
  appointmentdate: currentDate,
  searchflag: currentPatient.patientid,
  dashfilter: null,
  filterarr: [],
  start: 0,
  limit: 0,
};

const dashboarddata = await api.post(
  `/v1/${practiseid}/appointments/dashboard`,
  payload
);

setFetchedData((prevData) => {
  // Check API success and valid data
  if (
    dashboarddata?.status === 200 &&
    dashboarddata?.data?.length > 0
  ) {
    const apiItem = dashboarddata.data[0];

    return prevData.map((item) =>
      item.id === apiItem.id
        ? { ...item, ...apiItem } // ✅ Replace with complete API object
        : item
    );
  }

  // ❌ If condition fails → fallback to your original logic
  return prevData.map((item) =>
    item.id === data.id
      ? {
          ...item,
          copay: copay || 0,
          acctbalance: paymentOnAccount || 0,
        }
      : item
  );
});
        // setFetchedData((prevData) =>
        //   prevData.map(
        //     (item) =>
        //       item.id === data.id
        //         ? { ...item, copay: copay || 0 ,acctbalance:paymentOnAccount||0} // update only room_no
        //         : item, // keep others unchanged
        //   ),
        // );
        dispatch(
          showToast({
            message: response.message,
            severity: "success",
          }),
        );

        closePaymentModal();
      } else {
        dispatch(
          showToast({
            message: response.message,
            severity: "info",
          }),
        );
      }

      handleGetPayment({ data: currentPatient });
    } catch (error) {
      console.error("Error submitting payment:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatus = async (selectedColor) => {
    const formattedStartDate = dayjs(currentPatient.startdate).format(
      "YYYY-MM-DD",
    );
    const payload = {
      patient_name: `${currentPatient.firstname} ${currentPatient.lastname}`,
      appointmentid: currentPatient.appointmentid,
      amount: selectedColor,
      type: "dele",
      searchdate: formattedStartDate,
      createdby: loginUser,
    };
    //here if deducatble and selected  plans send key  insuranceCoveredPlan:[]
    try {
      const response = await api.put(
        `/v1/${practiseid}/appointments/patient/${currentPatient.patientid}/payment/update`,
        payload,
      );
      if (response.status == 200) {
        setFetchedData((prevData) =>
          prevData.map(
            (item) =>
              item.id === data.id
                ? { ...item, deductiblemet: selectedColor } // update only room_no
                : item, // keep others unchanged
          ),
        );
      }
    } catch (error) {
      console.error("Error submitting payment:", error);
    }
  };
  const handleCheckboxChange = (color, tabName) => {
    if (tabName === "Deductible"||tabName==="Coinsurance") {
      setSelectedColor(color);
      setSelectedTab(tabName);
      setInsuranceModalOpen(true);
      return; // ❌ stop API
    }

    if (selectedColor === color) {
      setSelectedColor("");
      setSelectedTab("");
    } else {
      setSelectedColor(color);
      setSelectedTab(tabName);
    }

    handleStatus(color);
  };

  // const handleCheckboxChange = (color, tabName) => {
  //   if (selectedColor === color) {
  //     setSelectedColor('');
  //     setSelectedTab('');
  //   } else {
  //     setSelectedColor(color);
  //     setSelectedTab(tabName);
  //   }
  //   handleStatus(color);
  // };

  const handleNextPatient = () => {
    if (currentIndex < alldata.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevPatient = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  // useEffect(() => {
  //   if (currentPatient) {
  //     setCopay(currentPatient.copay_amt_paid || 0);
  //     setPaymentOnAccount(currentPatient.total_amount_paid || '');
  //     setDeductible(currentPatient.deductibleamt || 0);
  //   } else {
  //     setCopay(0.0);
  //     setPaymentOnAccount('');
  //     setDeductible(0.0);
  //   }

  //   // if (activeTab === 'payment') {
  //   //   setSelfPay('');
  //   //   setPaymentOnAccount('');
  //   //   setCoinsurance('');
  //   //   setDeductible('');
  //   //   setTotalAmount('0');
  //   //   setCopay(0.0);
  //   // } else if (activeTab === 'update') {
  //   //   setSelfPay('');
  //   //   setPaymentOnAccount('');
  //   //   setCoinsurance('');
  //   //   setDeductible('');
  //   //   setTotalAmount('0');
  //   // }
  // }, [activeTab, currentPatient]);
  const handleInsuranceSave = async (plans) => {
    setInsuranceModalOpen(false);
    setSelectedPlans(plans || []);

    const formattedStartDate = dayjs(currentPatient.startdate).format(
      "YYYY-MM-DD",
    );

    const payload = {
      patient_name: `${currentPatient.firstname} ${currentPatient.lastname}`,
      appointmentid: currentPatient.appointmentid,
      amount:selectedColor,
      type: "dele",
      searchdate: formattedStartDate,
      createdby: loginUser,
    };

    // send ONLY for deductible save
    if (Array.isArray(plans)) {
      payload.insuranceCoveredPlan = plans;
    }

    try {
      const response = await api.put(
        `/v1/${practiseid}/appointments/patient/${currentPatient.patientid}/payment/update`,
        payload,
      );

      if (response.status === 200) {
        // update deductible color
        setFetchedData((prev) =>
          prev.map((item) =>
            item.id === data.id ? { ...item, deductiblemet: selectedColor } : item,
          ),
        );

        // 🔥 fetch orders
        const ordersPayload = {
          patientid: data.patientid,
          orderdate: dayjs(data.startdate).format("YYYY-MM-DD"),
        };

        const ordersresponse = await api.post(
          `/v1/${practiseid}/orders/get`,
          ordersPayload,
        );

        if (ordersresponse.status === 200) {
          const apiOrders = ordersresponse.data;

          // 🔥 safe state update
          setFetchedData((prev) =>
            prev.map((patient) =>
              patient.patientid === data.patientid
                ? { ...patient, orders: apiOrders }
                : patient,
            ),
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-black bg-opacity-50 overflow-y-auto">
      <div className="flex justify-center min-h-screen py-10">
        <div className="bg-white p-6 rounded-lg max-w-[90%] lg:w-[35%] w-[80%] my-10">
          <div className="w-full justify-between flex border-b mb-2">
            <h2 className="text-xl font-semibold text-[#09090B]">
              Patient {currentIndex + 1} of {alldata.length}
            </h2>
            <ClearIcon onClick={()=>{
            setPrevamount('')
              closePaymentModal()
              }} className="cursor-pointer" />
          </div>
          <div className="flex items-center justify-between py-2">
            <button
              onClick={handlePrevPatient}
              disabled={currentIndex === 0}
              className="bg-[#E5E7EB] text-gray-600 rounded-md w-10 h-10 flex items-center justify-center  hover:bg-black hover:text-white active:bg-black "
            >
              <span className="flex justify-center items-center text-xl">
                {<ChevronLeftIcon />}
              </span>
            </button>
            <div className="rounded-[8.75px] border-2 border-[#E4E4E7] bg-[#FAFAFA]   py-2 text-center">
              <div className="flex m-2">
                <div
                  onClick={() => setPurposeModalOpen(true)}
                  className="cursor-pointer rounded-[8px] border border-[#E2E8F0] px-3 py-1 text-xs text-[#18181B]"
                >
                  {currentPatient?.purpose}
                </div>
              </div>

              <div className="text-lg font-semibold px-6">
                <span className="font-bold text-[20px] text-[#18181B]">
                  {currentPatient.firstname + " " + currentPatient.lastname}
                </span>{" "}
                {currentPatient.patientid}
              </div>
              <div className="text-sm text-[#3F3F46] mt-1">
                {formatDateTime(getpaymentData?.startdate,currentPatient?.start_time)}
              </div>
              <div className="text-sm text-[#52525C] mt-1">
                {currentPatient.insurancename}
              </div>
              <button
                onClick={() => {
                  if (homescreenprev.includes("Change Provider")) {
                    setProviderModalOpen(true);
                  }
                }}
                className="
    rounded-full 
    bg-[#E88D67] 
    text-white 
    font-semibold 
    mt-2
    px-4 
    py-2
    shadow-[0_10px_15px_-3px_rgba(232,141,103,0.20),_0_4px_6px_-4px_rgba(232,141,103,0.20)]
  "
              >
                {currentPatient?.linked_provider}
              </button>
            </div>
            <button
              onClick={handleNextPatient}
              disabled={currentIndex === alldata.length - 1}
              className="bg-black text-white rounded-md w-10 h-10 flex items-center justify-center hover:bg-gray-800 disabled:opacity-50"
            >
              <span className="flex justify-center items-center text-xl">
                {<ChevronRightIcon />}
              </span>
            </button>
          </div>
          {/* Tab Buttons */}
          <div className="flex bg-gray-100 rounded-lg p-2 gap-1">
            <button
              className={`py-2 px-4 text-[14px] font-inter outline-none w-full text-center ${activeTab === "payment" ? "text-black bg-[white] border-none" : "text-gray-400"}`}
              onClick={() => setActiveTab("payment")}
            >
              Update
            </button>
            <button
              className={`py-2 px-4 text-[14px] font-font1 outline-none w-full text-center ${activeTab === "update" ? "text-black bg-[white] border-none" : "text-gray-400"}`}
              onClick={() => setActiveTab("update")}
            >
              Pay
            </button>
          </div>

          {/* Tab Content */}
          <div className="mt-4">
            {/* Payment Tab Content */}
            {activeTab === "payment" && (
              <div>
                <div className="mt-4 flex gap-4 justify-center relative">
                  <div className="absolute left-6 top-2">
                    <div
                      className="mx-2 cursor-pointer"
                      onClick={hanldeFrontdeskModal}
                    >
                      {frontDesk === "N" ? (
                        <PersonalVideoIcon />
                      ) : (
                        <>
                        
                           <img src={cancelledDesk} className="mt-2" alt="$" />
                        </>
                     
                      )}
                    </div>
                  </div>
                  <div
                    className={`flex cursor-pointer items-center flex-col  ${
                      selectedColor === "58D68D" ? "" : ""
                    }`}
                    onClick={() => handleCheckboxChange("58D68D", "Covered")}
                  >
                    <input
                      className="w-4 h-4 peer appearance-none mt-1 rounded-full border-2 border-[#58D68D] checked:bg-[#58D68D] ring-2 ring-white"
                      name="updateOption"
                      id="option1"
                      type="checkbox"
                      checked={selectedColor === "58D68D"}
                    />
                    <label className="block text-sm font-medium mb-1 text-[#71717A]">
                      Covered
                    </label>
                  </div>
                  <div
                    className={`flex cursor-pointer items-center flex-col px-2 `}
                    onClick={() =>
                      handleCheckboxChange("F9E79F", "Coinsurance")
                    }
                  >
                    <input
                      className="w-4 h-4 peer appearance-none mt-1 rounded-full border-2 border-[#F59E0B] checked:bg-[#F59E0B] ring-2 ring-white"
                      name="updateOption"
                      id="option2"
                      type="checkbox"
                      checked={selectedColor === "F9E79F"}
                    />
                    <label className="block text-sm font-medium mb-1 text-[#71717A]">
                      Coinsurance
                    </label>
                  </div>
                  <div
                    className={`flex cursor-pointer items-center flex-col px-2 ${
                      selectedColor === "F3082C"
                        ? "border-[#F43F5E]"
                        : "border-gray-300"
                    }`}
                    onClick={() => handleCheckboxChange("F3082C", "Deductible")}
                  >
                    <input
                      className="w-4 h-4 peer appearance-none mt-1 rounded-full border-2 border-[#F43F5E] checked:bg-[#F43F5E] ring-2 ring-white"
                      name="updateOption"
                      id="option3"
                      type="checkbox"
                      checked={selectedColor === "F3082C"}
                    />
                    <label className="block text-sm font-medium mb-1 text-[#71717A]">
                      Deductible
                    </label>
                  </div>
                  {selectedTab?.length ? (
                    <div onClick={() => handleCheckboxChange("0", "")}>
                      <CloseIcon />
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
                <div className="grid grid-cols-1 gap-4 mt-4">
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-medium font-semibold font-inter mb-1">
                      Co-pay
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>
                      <input
                        value={copay}
                        onChange={(e) => setCopay(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-semibold font-inter mb-1">
                      Balance
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>{" "}
                      <input
                        value={paymentOnAccount}
                        onChange={(e) => setPaymentOnAccount(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-semibold font-inter mb-1">
                      Deductible
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>
                      <input
                        value={deductible}
                        onChange={(e) => setDeductible(e.target.value)}
                        type="number"
                        disabled={
                           !(
      currentPatient?.visit_confirmation === "" ||
      currentPatient?.visit_confirmation === "visit_confirmation" ||
      currentPatient?.visit_confirmation === "Tele - Confirmed"
    )
                        }
                        className={`w-full border-none outline-none px-1 ${
                           !(
      currentPatient?.visit_confirmation === "" ||
      currentPatient?.visit_confirmation === "visit_confirmation" ||
      currentPatient?.visit_confirmation === "Tele - Confirmed"
    )
                            ? "cursor-not-allowed"
                            : ""
                        }`}
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-semibold font-inter mb-1">
                      Self Pay
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>{" "}
                      <input
                        value={selfPay}
                        onChange={(e) => setSelfPay(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-semibold font-inter mb-1">
                      Total
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm"></span>
                      <input
                        value={totalAmount}
                        onChange={(e) => setTotalAmount(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                  {selectedTab === "Coinsurance" && (
                    <div className="flex gap-4 justify-between items-center">
                      <label className="block text-sm font-semibold font-inter mb-1">
                        Co-Insurance
                      </label>
                      <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                        <span className="text-md font-inter text-gray-500">
                          %
                        </span>
                        <input
                          value={coinsurance}
                          onChange={(e) => setCoinsurance(e.target.value)}
                          type="number"
                          className="w-full border-none outline-none px-1"
                          placeholder=""
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="flex justify-start mt-3">
                  <div
                    onClick={() => {
                      handleGetpreviousPayment({ data: currentPatient });
                    }}
                    className="inline-flex items-center gap-2 cursor-pointer px-4 py-2 rounded-[22px] bg-white shadow-[0_0_4px_rgba(0,0,0,0.25)]"
                  >
                    {retrive}
                    <span>Retrieve last visit</span>
                  </div>
                </div>
                <div className="mt-4 flex flex-column gap-2 text-left">
                  <div className="text-sm font-semibold text-[#71717A]">
                    Insurance:{data?.insurancename}
                  </div>
                  {currentPatient?.patientid === data?.patientid &&
                    costEstimate > 0 && (
                      <div className="text-sm font-semibold text-[#71717A]">
                        Cost estimate: ${costEstimate}
                      </div>
                    )}

{/* {Number.isFinite(Number(finalformattedTotalcopay)) && (
  <div className="text-sm font-semibold text-[#71717A]">
    Amount DUE: ${Number(finalformattedTotalcopay)}
  </div>
)} */}

                  <button
                    onClick={() => handleUpdatePay(data)}
                    disabled={loading}
                    className="w-full py-2 bg-black text-white rounded-lg flex items-center justify-center"
                  >
                    {loading ? (
                      <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span>
                    ) : (
                      "Update Payment"
                    )}
                  </button>
                </div>
              </div>
            )}

            {/* Update Tab Content */}
            {activeTab === "update" && (
              <div>
  {Array.isArray(prevamount) && prevamount.length > 0 ? (
    <div className="flex justify-center items-center ">


  <div className="text-center flex items-center font-bold text-[#71717A]">
    Amount Paid: ${prevamount[0].amount} on{" "}
    {new Date(prevamount[0].payment_date).toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    })}
{prevamount.length > 1 && (
  <FontAwesomeIcon
    icon={faEye}
    className="ml-2 text-[#71717A] cursor-pointer"
    onClick={() => setShowPaymentsHistory(true)}
  />
)}
  </div>

    </div>

) : null}
                <div className="text-[17px] font-inter mb-1 text-left">
                  Payment method
                </div>
                <div className="flex gap-4 justify-between flex-col items-center mt-2 mb-2">
                  <select
                    onChange={handlePaymentMethodChange}
                    className="border rounded-lg px-2 py-2 w-[100%]"
                  >
                    <option value="">Select Payment method</option>
                    {loading ? (
                      <option disabled>Loading...</option>
                    ) : (
                      PaymentMethod.map((payment) => (
                        <option key={payment.id} value={payment.id}>
                          {payment.method}
                        </option>
                      ))
                    )}
                  </select>
                  {selectedPaymentMethod &&
                    !(selectedPaymentMethod.method === "CASH") && (
                      <div className="w-full">
                        <label className="block mb-1 my-0 text-left">
                          {" "}
                          {selectedPaymentMethod.method === "CHECK"
                            ? "Check Number"
                            : "Enter 4-digit number"}
                        </label>
                        <input
                          type="text"
                          value={ccnumber}
                          // onChange={(e) => setCcnumber(e.target.value)}
                          onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setCcnumber(value);
                              }
                            }}
                          maxLength={selectedPaymentMethod.method === "CHECK" ? 15 : 4}   
                          pattern={selectedPaymentMethod.method === "CHECK" ? "[0-9]+" : "[0-9]{4}"}
                          placeholder={selectedPaymentMethod.method === "CHECK" ? "Check number" : "4 digits"}
                          // maxLength="4"
                          // pattern="[0-9]{4}"
                          // placeholder="4 digits"
                          className="border rounded-lg px-2 py-1  w-[100%]"
                        />
                      </div>
                    )}
                </div>

                <p className="text-[16px]  font-semibold mb-2 text-left">
                  Payment Type
                </p>
                <div className="grid grid-cols-1 gap-4 mt-1">
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-medium font-semibold font-inter mb-1">
                      Co-pay
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>
                      <input
                        value={copay}
                        onChange={(e) => setCopay(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-medium font-semibold font-inter mb-1">
                      Self Pay
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>{" "}
                      <input
                        value={selfPay}
                        onChange={(e) => setSelfPay(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-medium font-semibold font-inter mb-1 w-[80px] text-left">
                      Payment on Account
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>
                      <input
                        value={paymentOnAccount}
                        onChange={(e) => setPaymentOnAccount(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>

                  <div className="flex gap-4 justify-between items-center">
                    <label className="block text-sm font-medium font-semibold font-inter mb-1">
                      Total Amount
                    </label>
                    <div className="flex items-center w-[70%] border rounded-lg px-2 py-1">
                      <span className="text-sm">
                        <img src={dollarImage} alt="%$" />
                      </span>
                      <input
                        value={totalAmount}
                        onChange={(e) => setTotalAmount(e.target.value)}
                        type="number"
                        className="w-full border-none outline-none px-1"
                        placeholder=""
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex justify-start mt-3">
                  {/* <div             onClick={()=>{handleGetpreviousPayment({data:currentPatient})}}
className="inline-flex items-center gap-2 cursor-pointer px-4 py-2 rounded-[22px] bg-white shadow-[0_0_4px_rgba(0,0,0,0.25)]">
  {retrive}
  <span>Retrieve last visit</span>
</div> */}
                </div>

                <div className="mt-4 flex flex-column gap-2 text-left">
                  <div className="text-sm font-semibold text-[#71717A] mt-1">
                    {data.insurancename}
                  </div>

                  <button
                    onClick={() => handlePaySubmit(data)}
                    disabled={loading}
                    className="w-full py-2 bg-black text-white rounded-lg flex items-center justify-center"
                  >
                    {loading ? (
                      <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span>
                    ) : (
                      "Pay"
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
          {providerModalOpen && (
            <ProviderModal
              open={providerModalOpen}
              current={currentPatient?.linked_provider}
              onClose={() => setProviderModalOpen(false)}
              selectedCard={currentPatient}
              setFetchedData={setFetchedData}
              setProviderModalOpen={setProviderModalOpen}
            />
          )}
          {frontdeskModal && (
            <ConfirmFrontdesk
              frontDesk={frontDesk}
              handleFrontDeskToggle={handleFrontDeskToggle}
              setfrontdeskModal={setfrontdeskModal}
            />
          )}
          <InsurancePlansModal
            open={insuranceModalOpen}
            preSelected={selectedPlans}
            onClose={() => setInsuranceModalOpen(false)}
            onSave={handleInsuranceSave}
          />

          <ToastMessage
            message={alertmessage}
            severity={severity}
            open={open}
            handleClose={handlealert}
          />
          {purposeModalOpen && (
            <PurposeOfVisitModal
              open={purposeModalOpen}
              setFetchedData={setFetchedData}
              setPurposeModalOpen={setPurposeModalOpen}
              onClose={() => setPurposeModalOpen(false)}
              selectedCard={data}
            />
          )}
          {/* Backdrop Loader */}
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
  {showPaymentsHistory && (
  <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40 p-3 sm:p-4">
    
    <div className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[80vh] flex flex-col">

      {/* Header */}
      <div className="flex justify-between items-center border-b px-3 py-2 sm:px-4 sm:py-3">
        <h3 className="font-semibold text-base sm:text-lg">
          Payment History
        </h3>
        <CloseIcon
          className="cursor-pointer text-gray-600"
          onClick={() => setShowPaymentsHistory(false)}
        />
      </div>

      {/* Payments list */}
      <div className="overflow-y-auto px-3 py-2 sm:px-4 sm:py-3 space-y-2 flex-1">

        {prevamount.map((item, index) => (
          <div
            key={index}
            className="flex justify-between items-center border rounded-md px-2 py-2 sm:px-3"
          >
            <div className="text-xs sm:text-sm text-gray-600">
              {new Date(item.payment_date).toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
              })}
            </div>

            <div className="font-semibold text-sm sm:text-base text-gray-800">
              ${item.amount}
            </div>
          </div>
        ))}

      </div>

    </div>
  </div>
)}
        </div>
      </div>
    </div>
  );
};

export default Paymentsmodal;
